import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@lift-admin/utils/apiClient";
import { Toastify } from 'lift-ui';
// import { configApi } from '@/features/report-builder/services/configApi';
import { trpc } from "@/shared/utils/trpc";

export type deployReport = {
    requestID: number;
}
export const configApi = {
  deployReport: (requestID: number) => {
    return trpc.drawerItems.deployReport.mutate({
        requestID
    })
  },
  getConfig: (reportURL: string) => {
    return trpc.reportBuilder.getConfig.query({ reportURL });
  },
};
// hooks.ts
export const useConfigQuery = (reportURL: string) => {
  return useQuery({
    queryKey: ['config', reportURL],
    queryFn: () => configApi.getConfig(reportURL),
    enabled: false,     // don’t run on mount
    retry: false,
  });
};


export const useDeleteReportConfig = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: deployReport) =>
      configApi.deployReport(
        payload.requestID
      ),
    onSuccess: (_, { requestID }) => {
      // Invalidate the config query cache for the given report URL to refetch updated config
      queryClient.invalidateQueries({ queryKey: ['deployReportConfig', requestID] });
      // Toastify('success', 'Config saved successfully!');
    },
    onError: (error: any) => {
      // Toastify('error', error?.message || 'Error deploying config');
    }
  });
};
